import { render, staticRenderFns } from "./UniverskinHSection.vue?vue&type=template&id=1f952c7e&scoped=true"
import script from "./UniverskinHSection.vue?vue&type=script&lang=js"
export * from "./UniverskinHSection.vue?vue&type=script&lang=js"
import style0 from "./UniverskinHSection.vue?vue&type=style&index=0&id=1f952c7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f952c7e",
  null
  
)

export default component.exports